var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.overlay},[_c('img',{class:_vm.$style.loader,attrs:{"src":_vm.loader}}),_vm._v(" "),_c('p',{class:_vm.$style.message},[_vm._v("Searching...")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21592b64","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/SearchContacts/SearchMode/SearchingComponent.vue
// module id = 4rFe
// module chunks = 1